/* eslint-disable react/forbid-component-props, react-hooks/exhaustive-deps */
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ReactCookies from 'react-cookies';
import { STATUS_ELIGIBLE, COOKIES } from '../../../brands/default/constants';
import { VIP_SUBSCRIBE_CHECKBOX } from '../../../brands/default/content/components/checkout';
import { trackEvent } from '../../../helpers/analytics';
import { upadateVipStatus } from '../../../helpers/vipSubscribeHelper';
import VipInfoModal from '../VipInfoModal';

export default function VipSubscribeCheckbox({
  currencySymbol,
  isExclusiveProductInBasket = false,
  setVipOptIn,
  userVipStatus,
  vipOneYearPrice,
}) {
  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const onModal = (event) => {
    if (event.key && event.key === 'Enter') {
      setShowModal(true);
    }
  };

  const onChange = (event) => {
    setIsChecked(event.target.checked);
    setVipOptIn(event.target.checked);
    // remember the users selection
    ReactCookies.save(COOKIES.vipChecked, event.target.checked, {
      domain: `.${process.env.NEXT_PUBLIC_DOMAIN_NAME}`,
      maxAge: 60 * 60 * 24 * 365,
      path: '/',
    });
    upadateVipStatus(event.target.checked);
  };

  useEffect(() => {
    // did the user click the checkbox
    const cookieValueVipChecked = ReactCookies.load(COOKIES.vipChecked);
    // can auto check if user didn't click or has checked themselves
    const value =
      userVipStatus === STATUS_ELIGIBLE ||
      typeof cookieValueVipChecked === 'undefined' ||
      cookieValueVipChecked === 'true' ||
      isExclusiveProductInBasket;
    setIsChecked(value);
    setVipOptIn(value);
  }, []);

  return (
    <>
      <div className="vip-subscribe">
        <label className="vip-subscribe__label">
          <input
            checked={isChecked}
            disabled={isExclusiveProductInBasket}
            onChange={onChange}
            type="checkbox"
            value={isChecked}
          />
          <span className="vip-subscribe__label-text">
            {isExclusiveProductInBasket
              ? `${VIP_SUBSCRIBE_CHECKBOX.vipExclusiveInfo}`
              : `${VIP_SUBSCRIBE_CHECKBOX.vipSubscribeTitle} ${currencySymbol}${vipOneYearPrice}`}
          </span>
        </label>
        <FontAwesomeIcon
          className="vip_info_icon"
          icon={faInfoCircle}
          onClick={() => {
            trackEvent('wvip_i');
            setShowModal(true);
          }}
          onKeyDown={onModal}
          role="button"
          tabIndex={0}
        />
      </div>
      <VipInfoModal onClose={() => setShowModal(false)} show={showModal} />
      <style jsx>{`
        .vip-subscribe {
          align-items: center;
          display: flex;
          margin-bottom: 10px;
        }
        .vip-subscribe__label {
          align-items: center;
          display: flex;
          margin-bottom: 0;
        }
        .vip-subscribe__label-text {
          margin-left: 8px;
          margin-right: 8px;
        }
        :global(.vip_info_icon) {
          color: #cccccc;
          height: 24px !important;
          width: 24px !important;
        }
        :global(.vip__modal .modal-body) {
          padding-top: 0;
        }
      `}</style>
    </>
  );
}

VipSubscribeCheckbox.propTypes = {
  currencySymbol: PropTypes.string,
  isExclusiveProductInBasket: PropTypes.bool,
  setVipOptIn: PropTypes.func,
  userVipStatus: PropTypes.string,
  vipOneYearPrice: PropTypes.number,
};
